///
/// EarthBrowser
///
/// Created by Matt Giger on 1/7/2026
/// Copyright (c) 2026 Geodata Labs
///

import { type EarthBrowserContext } from "@/earthbrowser/EarthBrowserContext"
import { type TileSeries } from "@/earthbrowser/datasets/TileSeries"
import { geographic } from "@/earthbrowser/utils/geographic"
import { type Renderer } from "@stovokor/engine/Renderer"
import { type vec3 } from "@stovokor/math/vector"
import { type TileInterface } from "./EarthTile"
import { type WebMercatorTileId } from "./WebMercatorTileId"
import { WebMercatorOverlayTileGeometry } from "./WebMercatorOverlayTileGeometry"
import { WebMercatorOverlayTileMaterial } from "./WebMercatorOverlayTileMaterial"

export class WebMercatorOverlayTile implements TileInterface {
	public tileId: WebMercatorTileId
	public hitCount: number = 0
	public lastAccess: number = 0

	public geometry: WebMercatorOverlayTileGeometry
	public material: WebMercatorOverlayTileMaterial

	public renderer?: Renderer
	private _center?: vec3

	constructor(
		context: EarthBrowserContext,
		tileId: WebMercatorTileId,
		tileSeries: TileSeries,
		parentMaterial?: WebMercatorOverlayTileMaterial
	) {
		this.tileId = tileId
		this.geometry = new WebMercatorOverlayTileGeometry(context, tileId)
		this.material = new WebMercatorOverlayTileMaterial(context, tileId, tileSeries, parentMaterial)
	}

	/** World position of the tile center on the surface, for depth sorting */
	public get center(): vec3 {
		if(!this._center) {
			const [lon, lat] = this.tileId.centerLonLatRad
			this._center = new geographic(lon, lat, 0).cartesian
		}
		return this._center
	}

	public destroy(): void {
		this.material.destroy()
		this.geometry.destroy()
	}

	public get readyToBeParent(): boolean {
		return this.material.readyToBeAParent
	}
}


